import React from 'react';

export default function Question12(){
    return(
        <div className="question mt-40">
            <h4 id='q12' className="h-4 h-bold">
                <span style={{opacity:"0.4", marginRight:"10px"}}>
                    13.
                </span>
                Links to Other Websites
            </h4>
            <p className="paragraph p-adjustment text-left">
            This Privacy Policy applies only to our Services. The Services may contain links to other websites, goods or services not operated or controlled by Invoice Point. We are not responsible for the content, accuracy, or opinions expressed in such websites, and such websites are not investigated, monitored, or checked for accuracy or completeness by us. Please remember that when you use a link to go from the Services to another website, our Privacy Policy is no longer in effect. Your browsing and interaction on any other website, including those that have a link in our App and our Website, is subject to that website’s own rules and policies. Such third parties may use their own cookies or other methods to collect information about you.
            </p>
        </div>
    )
}